// Module
var code = `<div>
  <p>An authenticator app lets you generate security codes on your phone. The app recommended by Nextbank
    is <strong>Google Authenticator</strong>), which you can get from the Google Play / Apple AppStore.</p>
  <span ng-show="\$ctrl.configureViaQr">
    <p>To configure it to work with your account please use your app to scan the QR-code below or <button
        class="mfa-configuration__toggle-link btn-link"
        ng-click="\$ctrl.toggleConfigurationWay()">type your secret directly</button>.</p>
    <div qr-code="\$ctrl.secretTotpURI" class="text-center"></div>
  </span>
  <span ng-hide="\$ctrl.configureViaQr">
    <p>To configure it to work with your account please type secret code below in your app or <button
    class="mfa-configuration__toggle-link btn-link"
    ng-click="\$ctrl.toggleConfigurationWay()">scan QR code</button>.</p>
    <pre class="mfa-configuration__secret-code text-center">{{\$ctrl.humanReadableSecret}}</pre>
  </span>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/mfa-configuration/mfa-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;